import { create } from 'zustand';
import type { Session } from '@supabase/supabase-js';

export interface AdminProfile {
  id: string;
  email: string | null;
  full_name: string;
  role: 'admin' | 'director' | 'monitor';
  avatar_url: string | null;
  is_physical_trainer: boolean;
}

interface AuthState {
  session: Session | null;
  profile: AdminProfile | null;
  loading: boolean;
  setSession: (session: Session | null) => void;
  setProfile: (profile: AdminProfile | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  profile: null,
  loading: true,
  setSession: (session) => set({ session }),
  setProfile: (profile) => set({ profile }),
  setLoading: (loading) => set({ loading }),
  reset: () => set({ session: null, profile: null, loading: false }),
}));
